import httpClient from '@/libs/http-client'
import httpClientHub from '@/libs/http-client-hub'
import { request } from '@/libs/api-request'
import { HTTP_HEADER_SKIP_ERROR } from '@/libs/constants'

export function authRealTime (aid) {
  const data = {
    aid: aid
  }

  return httpClientHub.post('/v1/samsung/heatmap/apply/realtime_auth', data).then(response => {
    return response.data.result
  })
}

export function getPageList (force) {
  const config = {
    method: 'post',
    url: '/apply/get_list'
  }

  return request(config, force)
}

export function getApply (aid) {
  let url = `/apply/${aid}`

  return httpClient.get(url).then(response => {
    if (response.data && response.data.result && !response.data.result.matchType) {
      response.data.result.matchType = 'exact'
    }
    return response.data.result
  })
}

export function getApplyByAbTest (aid) {
  let url = `/apply/by_abtest/${aid}`

  return httpClient.get(url).then(response => {
    if (response.data && response.data.result && !response.data.result.matchType) {
      response.data.result.matchType = 'exact'
    }
    return response.data.result
  })
}

export function getCode (sid) {
  const url = `/apply/get_code_v2`

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function getCodeForAMP (sid) {
  const url = `/apply/get_code_amp/${sid}`

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function checkInstall (aid, url) {
  const apiUrl = '/apply/check_install'
  const params = {
    aid
  }

  const config = {
    headers: {
      [HTTP_HEADER_SKIP_ERROR]: '1'
    },
    timeout: 6000
  }

  if (url) {
    params.url = url
  }

  return httpClient.post(apiUrl, params, config).then(response => {
    return response.data.result
  })
}

export function getDomains () {
  const url = '/samsung/apply/get_domains'

  return httpClient.post(url).then(response => {
    const items = response.data.result

    for (const item of items) {
      if (item.domain.startsWith('m.')) {
        item.tempDomain = item.domain
        item.order = 1
      } else {
        item.tempDomain = `m.${item.domain}`
        item.order = 0
      }
    }

    items.sort((a, b) => {
      if (a.tempDomain === b.tempDomain) {
        return a.order - b.order
      } else {
        return a.tempDomain.localeCompare(b.tempDomain)
      }
    })

    items.forEach(item => {
      delete item.tempDomain
      delete item.order

      item.site_code.sort((a, b) => {
        return a.localeCompare(b)
      })
    })
    return items
  })
}

export function getPageListBySid (sid, siteCode) {
  const url = '/samsung/apply/get_list_by_sid'

  return httpClient.post(url, { sid: sid, site_code: siteCode }).then(response => {
    return response.data.result
  })
}

export function insertApply (values) {
  const url = `/samsung/apply/insert_apply`

  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}

export function bulkUpdate (values) {
  const url = `/apply/bulk_update`

  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}

export function validateUrl (url, bMobile, isCaptureUrl) {
  const apiUrl = '/apply/validate_url'
  const data = {
    url: isCaptureUrl ? null : url,
    captureUrl: isCaptureUrl ? url : null,
    bMobile: bMobile
  }

  // check: timeout length
  return httpClient.post(apiUrl, data, { timeout: 120000 }).then(response => {
    return response.data.result
  })
}

export function getEtcSiteCodeList (rhq) {
  const url = '/samsung/apply/get_site_code'
  const data = {
    rhq
  }
  return httpClient.post(url, data).then(response => {
    return response.data.result
  })
}

export function overlapUrl (url, isCaptureUrl, bAMP) {
  const apiUrl = '/apply/overlap_url'
  const data = {
    url: isCaptureUrl ? null : url,
    bAMP: bAMP
  }
  // check: timeout length
  return httpClient.post(apiUrl, data, { timeout: 120000 }).then(response => {
    return response.data.result
  })
}

export function getCategoryList (realDomain, siteCode) {
  const url = '/samsung/apply/get_category_list'
  const data = {
    realDomain,
    siteCode
  }

  return httpClient.post(url, data).then(response => {
    return response.data.result
  })
}

export function getLiveHeatmapUrl (aid) {
  const url = `/apply/live_heatmap/${aid}`

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function reportProblem (param) {
  const url = '/samsung/apply/report_problem'

  return httpClient.post(url, param).then(response => {
    return response.data.result
  })
}

export function shareList (aid) {
  const url = `/apply/share/list/${aid}`

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function shareCheck (param) {
  const url = `/apply/share/check/${param.aid}`

  const paramData = param.data

  return httpClient.post(url, paramData).then(response => {
    return response.data.result
  })
}

export function shareAdd (param) {
  const url = `/apply/share/add/${param.aid}`

  const paramData = param.data

  return httpClient.post(url, paramData).then(response => {
    return response.data.result
  })
}

export function shareRemove (iid) {
  const url = `/apply/share/remove/${iid}`

  return httpClient.post(url).then(response => {
    return response.data.result
  })
}

export function userApplyList (params) {
  const url = '/samsung/apply/user/list'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function checkDupUrl (params) {
  const url = '/samsung/apply/check_dup_url'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function pendingList (params) {
  const url = '/samsung/apply/pending/list'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function approve (params) {
  const url = '/samsung/apply/approve'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function getHtmldiff (params) {
  const url = '/samsung/apply/get_htmldiff'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function updateSPA (param) {
  const url = `/apply/update_spa`

  return httpClient.post(url, param).then(response => {
    return response.data.result
  })
}

export function getRealtimeList (param) {
  const url = '/v1/samsung/heatmap/realtime/list'

  return httpClientHub.post(url, param).then(response => {
    return response.data.result
  })
}

export function changeRealtimeReport (param) {
  const url = '/v1/samsung/heatmap/realtime/start'

  return httpClientHub.post(url, param).then(response => {
    return response.data.result
  })
}

export function offRealtimeReport (param) {
  const url = '/v1/samsung/heatmap/realtime/stop'

  return httpClientHub.post(url, param).then(response => {
    return response.data.result
  })
}

